import { Link } from "react-router-dom";

const ShippingInfo = () => {
  return (
    <div className="flex flex-col gap-6 lg:flex-row lg:gap-14 lg:*:w-1/2">
      <div>
        <img src="/images/home/shipping-info.jpg" loading="lazy" alt="小院咖啡" />
      </div>
      <div className="flex flex-col justify-center text-left">
        <h2 className="brand-heading-lg text-accent">訂購須知</h2>
        <h3 className="brand-heading-sm mt-3 text-secondary lg:mt-10">店家備貨流程</h3>
        <ul className="brand-text-md mt-3 list-outside list-disc space-y-4 pl-5 text-base-content lg:mt-6">
          <li>咖啡皆採「新鮮烘焙」，每週五晚上 12:00 結單統計，當週六/週日進行烘焙</li>
          <li>每週一/週二寄出，約２～３天可寄達</li>
          <li>標註「現貨」的商品，為近一週內烘焙的咖啡，下單後２天內寄出</li>
        </ul>
        <Link
          to="/shopping-info"
          className="brand-btn-base btn btn-secondary mt-6 w-full lg:mt-12 lg:w-fit"
        >
          瞭解更多
        </Link>
      </div>
    </div>
  );
};

export default ShippingInfo;
